import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '../../../../../common/Grid'
import AddonTile from './addonTile';
import { isMobile } from '../../../../../common/Helpers';
import AddonCarousel from './addonsCarousel';
import { getAddonData } from './addonsCommon';

const VoiceService = (props) => {
  const { refData, services = [], actionModal, bauTileData = [] } = props;
  if(!refData?.length){
    return null;
  }
  const addonCartInfo = Object.assign({}, ...bauTileData);
  const vzAddonsInCart = services.some((product) => product?.type === 'vzProtectHome' && addonCartInfo[product?.skuDetails?.sorId]?.quantity);
  const prepareTileData = (service, addonRefData) => {
    if(!service?.skuDetails){
      return {};
    }
    const {skuDetails, skuDetails: { sorId, productId, priceText }, type} = service;
    let addAddon;
    const tileData = getAddonData(service, addonRefData);
   const removeAddon = () => props.removeAddon(skuDetails, tileData.title, type);
   if(type === 'homePhoneService'){
    addAddon = () => actionModal(sorId, productId, priceText, tileData.title);
   }else{
    addAddon = () => props.addToCart(props.notifyMessage, skuDetails, type, tileData.title);
   }
   return { vzAddonsInCart, ...props,...tileData, ...{ addAddon, removeAddon } };
  }

  const tileData = props.services?.map((service) => prepareTileData(service, refData));

  return (
    ( isMobile() && services?.length > 1) ? 
        <AddonCarousel 
        data={tileData} 
        renderItem={(carouselProps) => <AddonTile {...carouselProps} />}
        />
      :
      <Row>
      {
      services.map((service) => (
          <Col key={service?.prodId} colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
            <AddonTile { ...prepareTileData(service, refData)} />
          </Col>
        ))
      }
    </Row>
  )};


VoiceService.propTypes = {
  service: PropTypes.array,
  refData: PropTypes.array,
  services: PropTypes.array,
  addAddon: PropTypes.func,
  actionModal: PropTypes.func,
  removeAddon: PropTypes.func,
  addToCart: PropTypes.func,
  notifyMessage: PropTypes.string,
  products: PropTypes.array,
  bauTileData: PropTypes.object,
};

export default VoiceService;